// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import {
    DisplayProductsResult,
    LoadRealTimeInventory,
    LoadRealTimePrices,
} from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";

interface Props {
    result: DisplayProductsResult;
}

type HandlerType = Handler<any, Props>;

const PopulateProps: HandlerType = props => {
    const state = props.getState();
    const { productIds } = props.parameter;
    const productInfosByProductId = state.pages.productList.productInfosByProductId;
    const productIdsToLoad = productIds.filter(
        (id: string) => !productInfosByProductId[id]?.pricing || !productInfosByProductId[id]?.inventory,
    );
    const productInfosToLoad = productIdsToLoad.reduce((acc: typeof productInfosByProductId, id: string) => {
        acc[id] = productInfosByProductId[id];
        return acc;
    }, {} as typeof productInfosByProductId);

    props.result = {
        productInfosByProductId: productInfosToLoad,
        products: productIdsToLoad.map((id: string) => ({ id })) as ProductModel[],
        isFiltered: false,
        productFilters: state.pages.productList.productFilters,
    };
};

const chain = [PopulateProps, LoadRealTimePrices, LoadRealTimeInventory];

const loadRealtimeData = createHandlerChainRunner(chain, "LoadRealtimeData");
export default loadRealtimeData;
